// Libraries
import React from 'react';
import {css} from 'aphrodite/no-important';
// Core
import CoreMetrics, {createExpandableMediaQueryStylesheet} from '../core/Metrics';
import {FixedSpace, FlexibleSpace} from '../core/Spacing';
// Controls
import Button from '../controls/Button';
import TextField from '../controls/TextField';
// Layouts
import ToolBar from '../layouts/ToolBar';

export default class SiteBar extends React.Component {
    static Variant = {
        Centered: "centered", // Default variant
        Stretched: "stretched",
    };
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            sitebarContent: {
                display: "flex",
                flexDirection: "row",
            },
            centered: {
                width: CoreMetrics.Grid.FixedWidth, // TODO: Remove this if we really aren't going to use this anymore
                marginLeft: "auto",
                marginRight: "auto",
            },
            stretched: {
                flexGrow: 1,
            },
            searchField: {
                width: 200,
            },
        });
        const {variant} = this.props;
        const variantStyle = styles[variant];
        return (
            <ToolBar>
                <div className={css([styles.sitebarContent, variantStyle])}>
                    <Button title="Subjects" style={Button.Style.Text} variant={Button.Variant.Dropdown} />
                    <FixedSpace />
                    <TextField styles={[styles.searchField]} placeholder="Search" />
                    <FlexibleSpace />
                    <Button title="Donate" style={Button.Style.Text} />
                    <FixedSpace />
                    <Button title="Join your class" style={Button.Style.Text} />
                    <FixedSpace />
                    <Button title="Sign in" style={Button.Style.Text} />
                    <FixedSpace />
                    <Button title="Sign up" style={Button.Style.Text} />
                </div>
            </ToolBar>
        );
    }
}
SiteBar.defaultProps = {
    variant: SiteBar.Variant.Centered,
};



// WEBPACK FOOTER //
// ./src/modules/SiteBar.jsx